import { Base, PageObject } from '@testsigmainc/models';
import { deserialize, serializable } from 'serializr';
import {
  AfterTestCaseDataDrivenFrequency,
  OutComeOfAfterCaseBlockResult,
} from '../enums/after-test-action.enum';

export class AfterTestCaseConfig extends Base implements PageObject {
  @serializable
  afterTestResultOutcome: OutComeOfAfterCaseBlockResult =
    OutComeOfAfterCaseBlockResult.SHOW_TEST_RESULT;
  @serializable
  dataDrivenFrequency: AfterTestCaseDataDrivenFrequency =
    AfterTestCaseDataDrivenFrequency.ALL_ITERATIONS;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(AfterTestCaseConfig, input));
  }
}
